import React, { useRef } from "react";
import { toPng } from "html-to-image";
import ShieldImg from "../../Assets/Icons/shield.png";

const AdminResultsShare = ({ match, turnir, onClose }) => {
  const cardRef = useRef(null);

  if (!match) return null;

  const teamAName = match.team_a?.name || "Domaći";
  const teamALogo = match.team_a?.logo_url || ShieldImg;
  const teamBName = match.team_b?.name || "Gosti";
  const teamBLogo = match.team_b?.logo_url || ShieldImg;

  // Podaci o turniru (logo i naziv)
  const turnirNaziv = turnir?.naziv || "TURNIR";
  const turnirLogo = turnir?.logo_url || ShieldImg;

  // Funkcija za preuzimanje slike
  const handleDownloadImage = async () => {
    if (cardRef.current) {
      try {
        const dataUrl = await toPng(cardRef.current, {
          cacheBust: true,
          quality: 0.95,
          fontEmbedCSS: "", // Sprječava grešku s učitavanjem web fontova
          filter: (node) => {
            // Filtrira eventualne vanjske skripte/stilove koji smetaju
            return true;
          },
        });

        const link = document.createElement("a");
        link.download = `${teamAName}-${match.scorea}_vs_${match.scoreb}-${teamBName}.png`;
        link.href = dataUrl;
        link.click();
      } catch (err) {
        console.error("Greška kod generiranja slike:", err);
        alert("Došlo je do greške prilikom preuzimanja slike.");
      }
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="share-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="share-modal-header">
          <h3>Instagram post</h3>
          <button className="close-modal-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* INSTAGRAM KARTICA (Format 1:1, čisti moderni dizajn bez gužve) */}
        <div className="insta-story-card" ref={cardRef}>
          {/* Vrh: Logo turnira i naziv */}
          <div className="insta-header-brand">
            <img
              src={turnirLogo}
              alt={turnirNaziv}
              className="turnir-logo-img"
            />
            <span className="turnir-title-badge">{turnirNaziv}</span>
          </div>

          {/* Faza natjecanja (Grupa / Završnica) */}
          <div className="insta-match-phase">
            {match.group_name === "Završnica"
              ? (() => {
                  const id = match.bracket_slot_id;
                  if (id >= 1 && id <= 8) return "1/8 FINALE";
                  if (id >= 9 && id <= 12) return "1/4 FINALE";
                  if (id === 13 || id === 14) return "POLUFINALE";
                  if (id === 15) return "FINALE";
                  if (id === 16) return "3. MJESTO";
                  return "ZAVRŠNICA";
                })()
              : match.group_name
                ? [
                    "finale",
                    "polufinale",
                    "četvrtfinale",
                    "osmina finala",
                    "šesnaestina finala",
                    "završnica",
                  ].some((term) =>
                    match.group_name.toLowerCase().includes(term),
                  )
                  ? match.group_name.toUpperCase()
                  : `GRUPA ${match.group_name.toUpperCase()}`
                : "ZAVRŠNICA"}
          </div>

          {/* Sredina: Timovi, grbovi i veliki rezultat */}
          <div className="insta-teams-row">
            <div className="insta-team">
              <div className="team-logo-wrapper">
                <img src={teamALogo} alt={teamAName} />
              </div>
              <span className="team-name">{teamAName}</span>
            </div>

            <div className="insta-score-box">
              <span className="score-num">{match.scorea ?? 0}</span>
              <span className="score-colon">:</span>
              <span className="score-num">{match.scoreb ?? 0}</span>
            </div>

            <div className="insta-team">
              <div className="team-logo-wrapper">
                <img src={teamBLogo} alt={teamBName} />
              </div>
              <span className="team-name">{teamBName}</span>
            </div>
          </div>

          {/* Dno: FucaScore branding */}
          <div className="insta-footer-brand">@fucascore</div>
        </div>

        <div className="share-modal-actions">
          <button className="download-img-btn" onClick={handleDownloadImage}>
            <i className="fi fi-rs-download"></i> Preuzmi sliku za Instagram
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminResultsShare;
